import AscMaintenanceDataContainer from './AscMaintenanceDataContainer'
import { PERMISSION_LEVEL_CONSTS, RESOURCES } from '@/utilities/appConsts'

const maintenanceDataRouter = {
  icon: 'mdi-alert-circle',
  path: '/maintenance-Data',
  name: 'MaintenanceData',
  display: true,
  component: AscMaintenanceDataContainer,
  meta: {
    primaryNavigation: true,
    requiresResourcePermission: {
      resource: RESOURCES.REPEATER_ISSUE,
      permissionLevel: PERMISSION_LEVEL_CONSTS.READ,
    },
    tooltip: 'View all maintenance data.',
    breadcrumbs: [
      {
        text: 'Home',
        to: '/',
      },
      {
        text: 'Maintenance Data',
      },
    ],
  },
  children: [],
}

export default maintenanceDataRouter
